module.exports = __webpack_public_path__ + "img/ms-logo-icon-new.21d5b601.svg";